import React, { useEffect } from 'react';
import s from './Products.module.scss';
import useGetProductsByStore from 'sdk/hooks/shop/useGetProductsByStore';
import ProductCard from '../../../ProductsByCategory/ProductCard';
import { normalizeProduct } from '../../../ProductsByCategory/ProductsByCategory';
import useIsAuth from 'sdk/hooks/useIsAuth';

interface ProductsProps {
    storeId: string;
}

const Products: React.FC<ProductsProps> = ({ storeId }) => {
    const { data: products, refetch } = useGetProductsByStore(storeId);
    const { data: isAuthData } = useIsAuth();
    const userId = isAuthData?.user?.id;

    useEffect(() => {
        if (storeId) {
            refetch();
        }
    }, [storeId, refetch]);

    if (!products || products.length === 0) {
        return (
            <div className={s.empty}>
                <p>No products available</p>
            </div>
        );
    }

    return (
        <div className={s.container}>
            <div className={s.grid}>
                {products?.map(item => (
                    <ProductCard key={item.id} product={normalizeProduct(item)} userId={userId} />
                ))}
            </div>
        </div>
    );
};

export default Products;